import L from 'leaflet';

import leafletLegendGenerator from './leafletLegendGenerator';

const TOP_BUTTON_POSITION = 0;
const TOP_DROPDOWN_POSITION = TOP_BUTTON_POSITION + 30;

const CONTAINER_STYLE = `
  position: relative;
  width: 34px;
  height: 34px;
  cursor: pointer;
`;

const BUTTON_STYLE = `
  position: absolute;
  right: 0px;
  top: ${TOP_BUTTON_POSITION}px;
`;

const DROPDOWN_STYLE = `
  position: absolute;
  display: inline-block;
  border: none;
  right: 17px;
  top: ${TOP_DROPDOWN_POSITION}px;
  padding: 0px;
  max-height: 0px;
  max-width: 0px;
  overflow-y: scroll;
  overflow-x: hidden;
  z-index: -1;
  transition: max-width 0.3s, max-height 0.3s, padding 0.1s 0.1s;
`;

const SVG_LEGEND = '<img src="/maps-buttons/capas.svg" style="height:100%;width:100%;" />';

L.Control.GeojsonLegend = L.Control.extend({
  options: {
    position: 'topright'
  },

  initialize(style, options) {
    L.Util.setOptions(this, options);

    this.style = style;
  },

  onAdd(map) {
    this.map = map;

    // eslint-disable-next-line no-param-reassign
    map.geojsonLegend = this;

    const container = L.DomUtil.create('div');
    this.button = L.DomUtil.create('div', 'float-right', container);

    const { button } = this;

    this.dropdown = L.DomUtil.create('div', 'alert alert-light');

    const { dropdown } = this;

    container.style.cssText = CONTAINER_STYLE;
    dropdown.style.cssText = DROPDOWN_STYLE;
    button.style.cssText = BUTTON_STYLE;

    L.DomEvent.disableClickPropagation(container);

    container.appendChild(dropdown);

    button.clicked = false;

    L.DomEvent.on(button, 'click', this.buttonClick, this);
    map.on('click', this.dropdownCollapse, this);
    map.on('mouseout', this.dropdownCollapse, this);

    button.innerHTML = SVG_LEGEND;
    this.addLegend();

    return container;
  },
  dropdownExpand() {
    this.dropdown.style.maxHeight = '40vh';
    this.dropdown.style.maxWidth = '50vw';
    this.dropdown.style.padding = '10px 80px 10px 10px';
    this.button.clicked = true;
  },
  dropdownCollapse() {
    this.dropdown.style.maxHeight = '0px';
    this.dropdown.style.maxWidth = '0px';
    this.dropdown.style.padding = '0px';
    this.button.clicked = false;
  },
  buttonClick() {
    if (!this.button.clicked) {
      this.dropdownExpand();
    } else {
      this.dropdownCollapse();
    }
  },

  addLegend() {
    const { style } = this;

    this.dropdown.innerHTML = leafletLegendGenerator(style);
  }
});

L.control.geojsonlegend = (style, opts) => new L.Control.GeojsonLegend(style, opts);

/**
 * Adds the legend to the geojson layers.
 *
 * @param {object} leafletMap - The leaflet map.
 * @param {object} style - The geojson style.
 */
const geojsonLegend = (leafletMap, style) => {
  L.control.geojsonlegend(style).addTo(leafletMap);
};

export default geojsonLegend;
